/**
 * SharedWithMePageNew — shared trips list with full data display.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSharedTrips } from '../hooks/useSharedTrips';
import { DataCard } from '../design-system/primitives/DataCard';
import { DataCardRow } from '../design-system/primitives/DataCardRow';
import { EmptyState } from '../components/shared/EmptyState';
import { SkeletonRow } from '../design-system/primitives/SkeletonRow';
import { Mail } from 'lucide-react';

function formatDate(dateStr: string): string {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function SharedWithMePageNew(): React.ReactElement {
  const navigate = useNavigate();
  const { data: trips, isLoading } = useSharedTrips();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Shared with Me</h1>
      {isLoading ? (
        <SkeletonRow count={3} width="100%" />
      ) : (trips || []).length > 0 ? (
        <div className="space-y-3">
          {(trips || []).map((t) => (
            <button key={t.id} onClick={() => navigate(`/share/${t.token ?? t.id}`)}
              className="w-full text-left bg-white dark:bg-surface-dark-card rounded-xl p-4 shadow-card hover:shadow-card-hover transition text-left">
              <DataCard title={t.name} subtitle={`${formatDate(t.startDate)} — ${formatDate(t.endDate)}`}>
                <DataCardRow label="Visits" value={`${t.visitCount} park visits`} />
                <DataCardRow label="Owner" value={t.isOwner ? 'You' : 'Shared with you'} />
              </DataCard>
            </button>
          ))}
        </div>
      ) : (
        <EmptyState icon={Mail} iconColor="text-gray-400" title="No shared trips" subtitle="When someone shares a trip with you, it will appear here." />
      )}
    </div>
  );
}
